import { Box, Stack, Button, Typography, Divider } from '@mui/material';
import EventInfo from './EventNav/EventInfo';
import EventSummary, { ResumeItem } from './EventNav/EventSummary';
import HeaderDesktop from './HeaderDesktop';
import { useTicketTypes } from '@/store'
import useMobile from '@/hooks/useMobile';
import useRecaptcha from '@/contexts/recaptcha/useRecaptcha';
import SweepstakesLayout from '../layouts/SweepstakesLayout';
import { useCheckoutGenerateOrder } from '@/hooks/checkout';


export default function SweepstakesEvent() {
  const { handleRecaptcha } = useRecaptcha();

  const { isMobile } = useMobile()


  const { data } = useTicketTypes();
  const { generateRegister, isLoading } = useCheckoutGenerateOrder();

  const onGenerateRegister = async (ticketType) => {
    const { token, recaptchaToken } = await handleRecaptcha();
    generateRegister(token, recaptchaToken, ticketType);
  };

  return (
    <>
      <HeaderDesktop />
      <SweepstakesLayout>
        <Box
          sx={{
            width: '100%',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: '40px',
            marginTop: isMobile ? 0 : '40px',
            padding: isMobile ? 2 : 0,
          }}
        >
          <Stack gap={3}>
            <EventSummary isPreRegister />
            <Stack gap={1}>
              <Box>
                <Typography sx={{ fontSize: '14px' }}>
                  Participa por un pase doble para asistir al concierto de cierre del FIFA World Cup 26
                  Trophy Tour by Coca-Cola. Porías ser uno de los afortunados en vivir el gran final de este
                  recorrido único de la Copa Mundial.
                </Typography>
              </Box>
            </Stack>
            <Button
              variant="contained"
              color="blt_black"
              sx={{ height: '45px', width: '100%' }}
              onClick={() => onGenerateRegister(data[0].id)}
              disabled={isLoading}
            >
              Participar
            </Button>
          </Stack>

          <Divider />
          <Box sx={{ mt: -2 }}>
            <EventInfo />
          </Box>
        </Box>
      </SweepstakesLayout>
    </>
  );
}
